import { request } from "../../helpers/requestHelper";
import { returnMsg } from "../../helpers/shop/paymentHelper";
import { retryPayment } from './retryPayment';
import { msg as swalMsg } from "../swal_msg";

import { SUPPORT_NUMBER_VIEW } from "../../constants/constants";

// generar referencia de orden para MercadoPago
export const mercadoPagoReference = async(model) => {
    try {
        const resp = await request('payment/mercadopago/preference', model, 'POST');
        const body = await resp.json();
        if (body.status) return body;
        else {
            if (body.msg === 'not-created') {
                swalMsg('error', 'Mercado Pago',
                'No se generó el pedido');
                return { status: false };
            } else return returnMsg(body, 'MercadoPago', model);
        }
    } catch (err) {
        swalMsg('error', 'Checkout',
        `No se pudo registrar el pedido. Comuníquese con nosotros: ${SUPPORT_NUMBER_VIEW}`);
        return { status: false };
    };
};

// generar referencia de orden para MercadoPago (intento sin promociones expiradas)
export const mercadoPagoReferenceFn = async(model, cartData) => {
    try {
        const resp = await request('payment/mercadopago/preference', model, 'POST');
        const body = await resp.json();
        if (body.status)
            return { ...body, cartData: { ...cartData } };
        else {
            if (body.msg === 'not-created') {
                swalMsg('error', 'Mercado Pago',
                'No se generó el pedido');
                return { status: false, cartData: { ...cartData } };
            } else return returnMsg(body, 'MercadoPago', model);
        }
    } catch (err) {
        swalMsg('error', 'Checkout',
        `No se pudo registrar el pedido. Comuníquese con nosotros: ${SUPPORT_NUMBER_VIEW}`);
        return { status: false, cartData: { ...cartData } };
    };
};

// otbener enlace de pago con MercadoPago
// nuevo intento de pago (pedido ya registrado)
export const mercadoPagoPayment = (_id, setDisabled) => {
    return retryPayment('MercadoPago', _id, setDisabled);
};
